import type { JobCustomParams } from '@/utils/jobCustomParameters';

/** 展示创建时保存的 key/value，目录改名或停用不改变历史任务的含义。 */
export default function JobCustomParametersSummary({ params }: { params: JobCustomParams }) {
  return (
    <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: 'minmax(100px, max-content) minmax(0, 1fr)', gap: '6px 16px', fontSize: 12 }}>
      {Object.entries(params).map(([key, value]) => (
        <div key={key} style={{ display: 'contents' }}>
          <dt style={{ color: '#6b7280', overflowWrap: 'anywhere' }}><code>{key}</code></dt>
          <dd style={{ margin: 0, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{typeof value === 'boolean' ? (value ? 'true（开启）' : 'false（关闭）') : value === '' ? '（空文本）' : String(value)}</dd>
        </div>
      ))}
    </dl>
  );
}
